import { Injectable } from '@angular/core';

import { ValidationService } from './validation.service';
import { Validators } from '@angular/forms';
import { FormlyFieldConfig, FormlyBootstrapModule, Field, FieldWrapper } from 'ng-formly';
import * as _ from "lodash";
import { LoopBackFilter, Entity, Entityfield, Entityrecord } from '../sdk/models/';
import { AccountApi, EntityApi, EntityfieldApi, EntityrecordApi } from '../sdk/services/custom';

@Injectable()
export class EntityService {

    constructor(private _EntityrecordApi: EntityrecordApi) {

    }

    constructFormFields(fields: any[], appId: string) {
        var formfields: any = [];
        var entityRecordFilter: LoopBackFilter = <LoopBackFilter>{
            'where': {}
        };
        var formFieldTemplate = {
            key: 'name',
            type: 'input-field',
            appId: appId,
            templateOptions: {
                type: 'text',
                placeholder: '',
                label: 'Field Name'
            },
            lifecycle: {
                onInit: function () {

                }
            }
        };
        for (let i in fields) {

            var formField = _.cloneDeep(formFieldTemplate);
            formField.type = 'input-field';
            formField.key = fields[i].name;
            formField.templateOptions.label = fields[i].label;
            formField.templateOptions.type = 'text';
            /*
                value: 'autonumber'
                value: 'formula'
                value: 'rollupsummary'
                value: 'lookup'
                value: 'externallookup'
                value: 'checkbox'
                value: 'currency'
                value: 'date'
                value: 'email'
                value: 'geolocation'
                value: 'number'
                value: 'percent'
                value: 'phone'
                value: 'picklist' - 'single, multi, radio'
                value: 'text'
                value: 'textarea'
                value: 'textarealong'
                value: 'textarearich'
                value: 'textencrypted'
                value: 'url'
            */
            if (fields[i].fieldtype === 'lookup') {
                //Get the look up values
                formField.type = 'select-component';
                formField['lookupfield'] = fields[i].lookupfield;
                formField.templateOptions['options'] = [];
                formField['lifecycle']['onInit'] = function () {
                    console.log('In init of select component');
                }
            }
            else if (fields[i].fieldtype === 'picklist') {
                if (fields[i].picklistfieldtype === 'radio') {
                    formField.type = 'picklist-radio';
                }
                else {
                    formField.type = 'picklist-lookup';
                }
                formField.templateOptions['options'] = [{ "label": "Name of the option", "value": "Value" }];
                if (fields[i].picklistvaluetype === 'custom') {
                    formField.templateOptions['options'] = fields[i].picklistcustomvalues;
                }
            }
            else if (fields[i].fieldtype === 'checkbox') {

            }
            else if (fields[i].fieldtype === 'currency') {

            }
            else if (fields[i].fieldtype === 'date') {

            }
            else if (fields[i].fieldtype === 'email') {
                formField.templateOptions.type = 'email'
                formField['validation'] = Validators.compose([ValidationService.emailValidator]);
            }
            else if (fields[i].fieldtype === 'geolocation') {

            }
            else if (fields[i].fieldtype === 'number') {

            }
            else if (fields[i].fieldtype === 'phone') {

            }
            else if (fields[i].fieldtype === 'textarea') {
                formField.type = 'textarea';
            }
            else if (fields[i].fieldtype === 'textarealong') {
                formField.type = 'textarea';
            }
            else if (fields[i].fieldtype === 'textarearich') {
                formField.type = 'textarea';
            }
            else if (fields[i].fieldtype === 'url') {
            }
            else if (fields[i].fieldtype === 'textencrypted') {
                formField.templateOptions.type = 'password'
            }
            else if (fields[i].fieldtype === 'readonlylabel') {
            }
            if (fields[i].required) {
                formField.templateOptions['required'] = true;
                formField.templateOptions.label = formField.templateOptions.label + ' *';
            }
            formfields.push(formField);
        }
        return formfields;

    }
    constructGridColumns() {

    }
}







// WEBPACK FOOTER //
// ./src/app/shared/services/entity.service.ts